/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCategoryPageQueryVariables = Types.Exact<{
  businessLine: Types.BusinessLine;
  categoryId: Types.Scalars["ID"]["input"];
}>;
export type GetCategoryPageQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    categoryPage?: {
      __typename?: "ShopCategoryPage";
      description?: string | null;
      handle?: string | null;
      image?: {
        __typename?: "ShopCategoryImage";
        altText: string;
        baseUrl: string;
        mediaPath: string;
      } | null;
    } | null;
  } | null;
};
export const GetCategoryPageDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getCategoryPage"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "businessLine"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "BusinessLine"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "categoryId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "businessLine"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "businessLine"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "categoryPage"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "categoryId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "categoryId"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CategoryPageHeader"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "CategoryPageHeader"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopCategoryPage"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "description"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "handle"
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetCategoryPageQuery__
 *
 * To run a query within a React component, call `useGetCategoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryPageQuery({
 *   variables: {
 *      businessLine: // value for 'businessLine'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetCategoryPageQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryPageQuery, GetCategoryPageQueryVariables> & ({
  variables: GetCategoryPageQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetCategoryPageQuery, GetCategoryPageQueryVariables>(GetCategoryPageDocument, options);
}
export function useGetCategoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryPageQuery, GetCategoryPageQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetCategoryPageQuery, GetCategoryPageQueryVariables>(GetCategoryPageDocument, options);
}
// @ts-ignore
export function useGetCategoryPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoryPageQuery, GetCategoryPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryPageQuery, GetCategoryPageQueryVariables>;
export function useGetCategoryPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryPageQuery, GetCategoryPageQueryVariables>): Apollo.UseSuspenseQueryResult<GetCategoryPageQuery | undefined, GetCategoryPageQueryVariables>;
export function useGetCategoryPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryPageQuery, GetCategoryPageQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetCategoryPageQuery, GetCategoryPageQueryVariables>(GetCategoryPageDocument, options);
}
export type GetCategoryPageQueryHookResult = ReturnType<typeof useGetCategoryPageQuery>;
export type GetCategoryPageLazyQueryHookResult = ReturnType<typeof useGetCategoryPageLazyQuery>;
export type GetCategoryPageSuspenseQueryHookResult = ReturnType<typeof useGetCategoryPageSuspenseQuery>;
export type GetCategoryPageQueryResult = Apollo.QueryResult<GetCategoryPageQuery, GetCategoryPageQueryVariables>;